import React from 'react';
import PropTypes from 'prop-types'
import Icon from "../Icon";

const SquareCompanyItem = ({name, addButton, ...rest}) => {
  return (
    <article
      className={`square-company-item cursor-pointer s-to-center s-mb-0 ${addButton && 'add-button'}`}
      {...rest}
    >
      <div className="square s-bg-blue s-hover-bg-alt-blue background-transition s-cross-center s-main-center normal-radius s-mb-8px">
        {addButton ? (
          <Icon svg="plus"
            size="2rem"
            color="var(--blue-600)"
          />
        ) : (
          <p className="s-mb-0 t1 s-color-white">{name.substring(0, 1).toUpperCase()}</p>
        )}
      </div>
      <p className="s-mb-0 small">{addButton ? 'Agrega una empresa' : name}</p>
    </article>
  );
};

SquareCompanyItem.propTypes = {
  name: PropTypes.string,
}

SquareCompanyItem.defaultProps = {
  name: 'nomineros',
}

export default SquareCompanyItem;
